// extracted by mini-css-extract-plugin
module.exports = {"base":"Grid_base__N2PTJ","border":"Grid_border__8N6iS"};